<div class="row">
    <div class="col-lg-12" id="pageSelection">
        <div class="card selectColumns isMinimizable minimize"
             [stepContent]="pdfPageStepContent"
             joyrideStep="pdfPageStep">
            <div class="card-header">
                <div class="card-title">
                    <i class="fa fa-angle-up"></i>
                    Personnalisation du PDF
                </div>
            </div>
            <div class="card-body">
                <mat-button-toggle-group class="container-fluid" [multiple]="true" #group="matButtonToggleGroup"
                                         [value]="user.user_dashboard.pdf_page"
                                         (change)="onPageChange(group.value)">
                    <div class="col-md-12 page-list">
                        <h5>Sélection des pages</h5>

                        <mat-button-toggle value="annonce">
                            Couverture
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="emplacement">
                            Emplacement
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="distance" class="last">
                            Map Lyon
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="secteur">
                            Analyse du secteur
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="copro">
                            La copropriété
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="photo" class="last">
                            Le bien
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="photo2">
                            Le bien 2
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="photo3">
                            Livraison
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="photo4" class="last">
                            Livraison 2
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="livraison">
                            livraison meuble
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="livraison2">
                            Livraison meuble 2
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="finance" class="last">
                            Bilan
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="finance_2" class="last">
                            Bilan comptable prévisionnel
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="resume">
                            Synthèse
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>

                        <mat-button-toggle value="final">
                            Couverture
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>
                    </div>
                </mat-button-toggle-group>
                <div class="col-md-12">
                    <h5>Qualité du rapport</h5>
                    <mat-button-toggle-group class="container-fluid" [ngModel]="user.user_dashboard.pdf_quality"
                                             (change)="user.user_dashboard.pdf_quality = $event.value;updateDashboard()">
                        <mat-button-toggle value="normal">
                            Standard / Rapide
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>
                        <mat-button-toggle value="hd" class="last">
                            Haute définition
                            <span class="check"><i class="fa fa-check"></i></span>
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="book">
    <div id="book">

        <a class="text-decoration-underline"
           [routerLink]="['/app/favorites/' + favorite.favorite_list.id + '/' + favorite.id + '/pdf/purpleimmobilier']">
            Dossier bancaire version LyBox
        </a>
        <button [hidden]="loading" [disabled]="!ready" (click)="createPdf()"
                class="dl_button btn btn-primary btn-lg text-white"
                [stepContent]="pdfDownloadStepContent"
                [stepContentParams]="{'user': authenticationService.currentUser}"
                joyrideStep="pdfDownloadStep">
            <mat-spinner diameter="25" color="second" [hidden]="ready"></mat-spinner>
            <i class="fa cfa cfa-pdf text-white"></i> Télécharger le rapport
        </button>
        <mat-spinner diameter="25" color="second" [hidden]="!loading"></mat-spinner>

        <div id="annonce" class="page"
             [stepContent]="pdfAnnonceStepContent"
             [stepContentParams]="{'user': authenticationService.currentUser}"
             (next)="openPageSelection()"
             joyrideStep="pdfAnnonceStep">
            <div class="subpage">
                <div>
                    <div class="title">
                        <input type="text" class="input_title"
                               [(ngModel)]="title">
                    </div>
                    <div class="sub_title">
                        <input type="text" class="input_title"
                               [(ngModel)]="sub_title">
                    </div>
                    <p *ngIf="favorite.visite_link" class="btn btn-purple">Visite virtuelle</p>
                </div>
            </div>
        </div>

        <div id="emplacement" class="page">
            <div class="subpage">
                <div class="subpageWrap">
                    <h2 class="{{ pdfConfig.h2_class}}">
                        L'emplacement
                    </h2>
                    <div class="row">
                        <div class="col-md-5">
                            <img class="img-fluid"
                                 src="{{apiUrl}}img/{{ favorite.id }}/city/purple"/>
                        </div>
                        <div class="col-md-6">
                            <h3>Adresse :</h3>
                            <p class="mb-0">
                                {{ favorite.adress }} <br/>
                                {{ favorite.ad_city.zip_code }} {{ favorite.ad_city.name }}
                            </p>
                            <h3 class="bold"> Le mot du conseiller :</h3>
                            <p class="wrap_textarea">
                                <textarea id="comment_city" matInput [(ngModel)]="favorite.comment_city"
                                          (ngModelChange)="edit($event, 'comment_city')"></textarea>
                            </p>
                        </div>
                    </div>
                </div>

                <p class="bottom_link {{ pdfConfig.display_legal_notice ? 'with_legal_notice' : ''}}">
                    <span>purpleimmobilier.fr - Analyses et dossier effectués en partenariat avec
                        <img width="25" src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                </p>
                <img *ngIf="pdfConfig.visuel_1 != ''" class="bottom_img" src="{{ pdfConfig.visuel_1 }}"/>
            </div>
        </div>


        <div class="text-center mb-4 mt-5">
            <label>Distance à afficher : </label>
            <input type="text" class="input_title ms-4" [(ngModel)]="distance_1"
                   (ngModelChange)="edit($event, 'distance')" placeholder="A 10 min">
            <input type="text" class="input_title ms-4" [(ngModel)]="distance_1_text"
                   (ngModelChange)="edit($event, 'distance')" placeholder="du centre ville de lyon">
            <input type="text" class="input_title ms-4" [(ngModel)]="distance_2"
                   (ngModelChange)="edit($event, 'distance')" placeholder="A 10 min">
            <input type="text" class="input_title ms-4" [(ngModel)]="distance_2_text"
                   (ngModelChange)="edit($event, 'distance')" placeholder="du centre ville de lyon">
            <input type="text" class="input_title ms-4" [(ngModel)]="distance_3"
                   (ngModelChange)="edit($event, 'distance')" placeholder="A 10 min">
            <input type="text" class="input_title ms-4" [(ngModel)]="distance_3_text"
                   (ngModelChange)="edit($event, 'distance')" placeholder="du centre ville de lyon">
        </div>

        <div id="distance" class="page">
            <div class="subpage">
                <p id="distance_1">
                    <span>{{ distance_1 }}</span>
                    {{ distance_1_text }}
                </p>
                <p id="distance_2">
                    <span>{{ distance_2 }}</span>
                    {{ distance_2_text }}
                </p>
                <p id="distance_3">
                    <span>{{ distance_3 }}</span>
                    {{ distance_3_text }}
                </p>
            </div>
        </div>

        <div id="secteur" class="page">
            <div class="subpage">
                <div class="subpageWrap">
                    <h2 class="{{ pdfConfig.h2_class}}">
                        Analyse du secteur
                    </h2>
                    <div class="kpi-3">
                        <div class="kpi kpi-color-1">
                            <img class="icon" src="assets/032-human-resources_white.png"/>
                            <label>Entreprises</label>
                            <p class="value">{{ favorite.ad_city.ets.ETNTOT21 }}</p>
                        </div>
                        <div class="kpi kpi-color-2">
                            <img class="icon" src="assets/dashboard_white.png"/>
                            <label>Tension locative</label>
                            <p class="value"
                               *ngIf="favorite.ad_city.loc_service_tensiometre.all.loc != '-1'">{{ favorite.ad_city.loc_service_tensiometre.all.loc }}
                                / 8</p>
                            <p class="value" *ngIf=" favorite.ad_city.loc_service_tensiometre.all.loc == '-1'">-</p>
                        </div>
                        <div class="kpi kpi-color-3">
                            <img class="icon" src="assets/measure_white.png"/>
                            <label>Écoles & universités</label>
                            <p class="value">{{ this.favorite.ad_city.ecole.tot_ecole }}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-5">
                            <div class="card">
                                <div class="card-header">
                                    <div class="card-title">
                                        <h3 class="{{ pdfConfig.h3_class}} text-color">Évolution des prix de
                                            l'immobilier</h3>
                                    </div>
                                </div>
                                <div class="card-body col-md-12">
                                    <div class="card-text row" *ngIf="priceEvolData.series.length > 0">
                                        <div echarts [options]="priceEvolOptions" [merge]="priceEvolData"
                                             class="priceEvolChart {{ pdfConfig.visuel_1 == '' ? 'small' : ''}}"
                                             (chartInit)="onPriceChartInit($event)"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-7">
                            <div class="card pb-0">
                                <div class="card-body col-md-12">
                                    <div class="card-text row">
                                        <div class="col-xl-3 col-6 text-center indicateur">
                                            <label>
                                                Niveau de vie moyen par habitant
                                                <br/>
                                                <br/>
                                            </label>
                                            <b class="value text-color">{{ favorite.ad_city.carac_commune.MED_NV | number: '1.0-0' }}
                                                <span
                                                    class="unit">€</span></b>
                                        </div>
                                        <div class="col-xl-3 col-6 text-center indicateur">
                                            <label>
                                                Taux de logements vacants
                                                <br/>
                                                <br/>
                                            </label>
                                            <b class="value text-color">{{ favorite.ad_city.logement.T_LV * 100 | number: '1.1-1' }}
                                                <span class="unit">%</span></b>
                                        </div>
                                        <div class="col-xl-3 col-6 text-center indicateur">
                                            <label>
                                                Taux d'étudiants
                                                <br/>
                                                <br/>
                                            </label>
                                            <b class="value text-color">{{ favorite.ad_city.carac_commune.T_etud * 100 | number: '1.1-1' }}
                                                <span class="unit">%</span></b>
                                        </div>
                                        <div class="col-xl-3 col-6 text-center indicateur">
                                            <label>
                                                Taux de chômage
                                                <br/>
                                                <br/>
                                            </label>
                                            <b class="value text-color">{{ favorite.ad_city.carac_commune.T_chom * 100 | number: '1.1-1' }}
                                                <span class="unit">%</span></b>
                                        </div>

                                        <div class="col-xl-3 col-6 text-center indicateur">
                                            <label>
                                                Taux de taxe foncière
                                                <br/>
                                                <br/>
                                            </label>
                                            <b class="value text-color">{{ favorite.ad_city.logement.TF * 100 | number: '1.1-1' }}
                                                <span class="unit">%</span></b>
                                        </div>
                                        <div class="col-xl-3 col-6 text-center indicateur">
                                            <label>
                                                Ancienneté des locataires
                                                <br/>
                                                <br/>
                                            </label>
                                            <b class="value text-color">{{ favorite.ad_city.logement.anc_loc_ann | number: '1.1-1' }}
                                                <span class="unit">ans</span></b>
                                        </div>
                                        <div class="col-xl-3 col-6 text-center indicateur">
                                            <label>
                                                Part des ménages ayant au moins 1 voiture
                                            </label>
                                            <b class="value text-color">{{ favorite.ad_city.logement['T_Men_1+voit'] * 100 | number: '1.1-1' }}
                                                <span class="unit">%</span></b>
                                        </div>
                                        <div class="col-xl-3 col-6 text-center indicateur">
                                            <label>
                                                Part des ménages ayant une place de parking
                                            </label>
                                            <b class="value text-color">{{ favorite.ad_city.logement.T_Men_park * 100 | number: '1.1-1' }}
                                                <span class="unit">%</span></b>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header">
                                    <div class="card-title">
                                        <h3 class="{{ pdfConfig.h3_class}} text-color">Évolution de la population</h3>
                                    </div>
                                </div>
                                <div class="card-body col-md-12">
                                    <div class="card-text row" *ngIf="popData.series.length > 0">
                                        <div echarts [options]="popOptions" [merge]="popData"
                                             class="popEvolChart"
                                             (chartInit)="onChartPopInit($event)"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <p class="bottom_link {{ pdfConfig.display_legal_notice ? 'with_legal_notice' : ''}}">
                    <span>purpleimmobilier.fr - Analyses et dossier effectués en partenariat avec
                        <img width="25" src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                </p>
                <img *ngIf="pdfConfig.visuel_1 != ''" class="bottom_img" src="{{ pdfConfig.visuel_1 }}"/>
            </div>
        </div>

        <div class="card">
            <div class="card-header">
                Sélection de photo
            </div>
            <div class="card-body picture_choice">
                <img
                    *ngFor="let picture of favorite.pictures; index as i;"
                    (click)="photo_9 = i;edit(null, 'pictures')"
                    [hidden]="picture == '/assets/no-photo.png'"
                    [ngClass]="{active : photo_9 == i}"
                    src="{{apiUrl}}img/{{ favorite.id }}/{{i}}?rand={{rand}}">
            </div>
        </div>

        <div id="copro" class="page">
            <div class="subpage">
                <div class="subpageWrap">
                    <h2 class="{{ pdfConfig.h2_class}}">
                        La copropriété
                    </h2>
                    <div class="row">
                        <div class="col-md-4">
                            <img class="img-fluid img-copro"
                                 src="{{apiUrl}}img/{{ favorite.id }}/{{photo_9}}?rand={{rand}}"/>
                        </div>
                        <div class="col-md-7">
                            <h3>Année de construction : {{ favorite.year_building }}</h3>
                            <h3>Étage : {{ favorite.floor }} / {{ favorite.floor_building }}</h3>
                            <h3>Ascenseur : {{ favorite.elevator == true ? 'Oui' : 'Non' }}</h3>
                            <h3>Chauffage : {{ favorite.heating }}</h3>
                            <h3>Charges de copropriété / an : {{ favorite.amount_copro }} €</h3>
                            <h3 class="bold">Description :</h3>
                            <p class="wrap_textarea">
                                <textarea id="comment_copro" matInput [(ngModel)]="favorite.comment_copro"
                                          (ngModelChange)="edit($event, 'comment_copro')"></textarea>
                            </p>
                        </div>
                    </div>
                </div>
                <p class="bottom_link {{ pdfConfig.display_legal_notice ? 'with_legal_notice' : ''}}">
                    <span>purpleimmobilier.fr - Analyses et dossier effectués en partenariat avec
                        <img width="25" src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                </p>
                <img *ngIf="pdfConfig.visuel_1 != ''" class="bottom_img" src="{{ pdfConfig.visuel_1 }}"/>
            </div>
        </div>

        <div class="card">
            <div class="card-header">
                Sélection de photo
            </div>
            <div class="card-body picture_choice">
                <img
                    *ngFor="let picture of favorite.pictures; index as i;"
                    (click)="photo_1 = i;edit(null, 'pictures')"
                    [hidden]="picture == '/assets/no-photo.png'"
                    [ngClass]="{active : photo_1 == i}"
                    src="{{apiUrl}}img/{{ favorite.id }}/{{i}}?rand={{rand}}">
            </div>
        </div>

        <div id="photo" class="page purple-page">
            <div class="subpage">
                <div class="subpageWrap">

                    <div class="row">
                        <div class="col-md-3">
                            <h2 class="{{ pdfConfig.h2_class}}">
                                Le bien
                            </h2>

                            <div class="kpi">
                                <img class="icon" src="assets/search_budget.png"/>
                                <label>Prix FPI</label>
                                <p class="value">{{ favorite.total_price | number: '1.0-0' }} €</p>
                            </div>
                            <div class="kpi">
                                <img class="icon" src="assets/measure_white.png"/>
                                <label>Superficie</label>
                                <p class="value">{{ favorite.square | number: '1.1-1' }} m²</p>
                            </div>
                            <div class="kpi">
                                <img class="icon" src="assets/analytics (4)_white.png"/>
                                <label>Rendement</label>
                                <p class="value">{{ favorite.efficiency_net | number: '1.1-1' }} %</p>
                            </div>
                            <div class="kpi">
                                <img class="icon" src="assets/dpe.png"/>
                                <label>DPE</label>
                                <p class="value">{{ favorite.energy_rate }}</p>
                            </div>
                        </div>
                        <div class="col-md-9 text-center">
                            <img class="picture img-fluid"
                                 src="{{apiUrl}}img/{{ favorite.id }}/{{photo_1}}?rand={{rand}}">
                        </div>
                    </div>
                </div>
                <p class="bottom_link {{ pdfConfig.display_legal_notice ? 'with_legal_notice' : ''}}">
                    <span>purpleimmobilier.fr<br/>Analyses et dossier effectués en partenariat avec lybox.fr<br/></span>
                </p>
                <img *ngIf="pdfConfig.visuel_1 != ''" class="bottom_img" src="{{ pdfConfig.visuel_1 }}"/>
            </div>
        </div>

        <div class="card">
            <div class="card-header">
                Sélection de photo
            </div>
            <div class="card-body picture_choice">
                <b>En haut à droite :</b><br/>
                <img
                    *ngFor="let picture of favorite.pictures; index as i;"
                    (click)="photo_2 = i;edit(null, 'pictures')"
                    [hidden]="picture == '/assets/no-photo.png'"
                    [ngClass]="{active : photo_2 == i}"
                    src="{{apiUrl}}img/{{ favorite.id }}/{{i}}?rand={{rand}}">

                <br/><b>En bas à gauche :</b><br/>
                <img
                    *ngFor="let picture of favorite.pictures; index as i;"
                    (click)="photo_3 = i;edit(null, 'pictures')"
                    [hidden]="picture == '/assets/no-photo.png'"
                    [ngClass]="{active : photo_3 == i}"
                    src="{{apiUrl}}img/{{ favorite.id }}/{{i}}?rand={{rand}}">

                <br/><b>En bas à droite :</b><br/>
                <img
                    *ngFor="let picture of favorite.pictures; index as i;"
                    (click)="photo_4 = i;edit(null, 'pictures')"
                    [hidden]="picture == '/assets/no-photo.png'"
                    [ngClass]="{active : photo_4 == i}"
                    src="{{apiUrl}}img/{{ favorite.id }}/{{i}}?rand={{rand}}">
            </div>
        </div>

        <div id="photo2" class="page">
            <div class="subpage">
                <div class="subpageWrap">
                    <h2 class="{{ pdfConfig.h2_class}}">
                        Le bien
                    </h2>
                    <div class="row">
                        <div class="col-md-6">
                            <h3 class="bold mt-0">Le mot du conseiller :</h3>
                            <p class="wrap_textarea">
                                <textarea id="comment" matInput [(ngModel)]="favorite.comment_building"
                                          (ngModelChange)="edit($event, 'comment_building')"></textarea>
                            </p>
                        </div>
                        <div class="col-md-6 pic_col">
                            <img class="picture img-fluid"
                                 src="{{apiUrl}}img/{{ favorite.id }}/{{ photo_2 }}?rand={{rand}}">
                        </div>
                        <div class="col-md-6 pic_col">
                            <img class="picture img-fluid"
                                 src="{{apiUrl}}img/{{ favorite.id }}/{{ photo_3 }}?rand={{rand}}">
                        </div>
                        <div class="col-md-6 pic_col">
                            <img class="picture img-fluid"
                                 src="{{apiUrl}}img/{{ favorite.id }}/{{ photo_4 }}?rand={{rand}}">
                        </div>
                    </div>
                </div>
                <p class="bottom_link {{ pdfConfig.display_legal_notice ? 'with_legal_notice' : ''}}">
                    <span>purpleimmobilier.fr - Analyses et dossier effectués en partenariat avec
                        <img width="25" src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                </p>
                <img *ngIf="pdfConfig.visuel_1 != ''" class="bottom_img" src="{{ pdfConfig.visuel_1 }}"/>
            </div>
        </div>

        <div class="card">
            <div class="card-header">
                Sélection de photo
            </div>
            <div class="card-body picture_choice">
                <img
                    *ngFor="let picture of favorite.pictures; index as i;"
                    (click)="photo_5 = i;edit(null, 'pictures')"
                    [hidden]="picture == '/assets/no-photo.png'"
                    [ngClass]="{active : photo_5 == i}"
                    src="{{apiUrl}}img/{{ favorite.id }}/{{i}}?rand={{rand}}">
            </div>
        </div>

        <div id="photo3" class="page purple-page">
            <div class="subpage">
                <div class="subpageWrap">

                    <div class="row">
                        <div class="col-md-3">
                            <h2 class="{{ pdfConfig.h2_class}}">
                                Livraison
                            </h2>
                            <div class="kpi pe-0">
                                <img class="icon" src="assets/003-paint.png"/>
                                <label>Travaux</label>
                                <p class="value">{{ favorite.works_total + favorite.other_fees_work  | number: '1.0-0' }}
                                    €</p>
                            </div>
                            <div class="kpi pe-0">
                                <img class="icon" src="assets/sofa.png"/>
                                <label>Mobilier</label>
                                <p class="value">{{ favorite.furniture_price | number: '1.0-0' }} €</p>
                            </div>
                        </div>
                        <div class="col-md-9 text-center">
                            <img class="picture img-fluid"
                                 src="{{apiUrl}}img/{{ favorite.id }}/{{ photo_5 }}?rand={{rand}}">
                        </div>
                    </div>
                </div>
                <p class="bottom_link {{ pdfConfig.display_legal_notice ? 'with_legal_notice' : ''}}">
                    <span>purpleimmobilier.fr<br/>Analyses et dossier effectués en partenariat avec lybox.fr<br/></span>
                </p>
                <img *ngIf="pdfConfig.visuel_1 != ''" class="bottom_img" src="{{ pdfConfig.visuel_1 }}"/>
            </div>
        </div>

        <div class="card">
            <div class="card-header">
                Sélection de photo
            </div>
            <div class="card-body picture_choice">
                <b>En haut à droite :</b><br/>
                <img
                    *ngFor="let picture of favorite.pictures; index as i;"
                    (click)="photo_6 = i;edit(null, 'pictures')"
                    [hidden]="picture == '/assets/no-photo.png'"
                    [ngClass]="{active : photo_6 == i}"
                    src="{{apiUrl}}img/{{ favorite.id }}/{{i}}?rand={{rand}}">

                <br/><b>En bas à gauche :</b><br/>
                <img
                    *ngFor="let picture of favorite.pictures; index as i;"
                    (click)="photo_7 = i;edit(null, 'pictures')"
                    [hidden]="picture == '/assets/no-photo.png'"
                    [ngClass]="{active : photo_7 == i}"
                    src="{{apiUrl}}img/{{ favorite.id }}/{{i}}?rand={{rand}}">

                <br/><b>En bas à droite :</b><br/>
                <img
                    *ngFor="let picture of favorite.pictures; index as i;"
                    (click)="photo_8 = i;edit(null, 'pictures')"
                    [hidden]="picture == '/assets/no-photo.png'"
                    [ngClass]="{active : photo_8 == i}"
                    src="{{apiUrl}}img/{{ favorite.id }}/{{i}}?rand={{rand}}">
            </div>
        </div>

        <div id="photo4" class="page">
            <div class="subpage">
                <div class="subpageWrap">
                    <h2 class="{{ pdfConfig.h2_class}}">
                        Livraison
                    </h2>
                    <div class="row">
                        <div class="col-md-6">
                            <h3 class="bold mt-0">Liste descriptive travaux :</h3>
                            <p class="wrap_textarea">
                                <textarea id="comment_work" matInput [(ngModel)]="favorite.comment_work"
                                          (ngModelChange)="edit($event, 'comment_work')"></textarea>
                            </p>
                        </div>
                        <div class="col-md-6 pic_col">
                            <img class="picture img-fluid"
                                 src="{{apiUrl}}img/{{ favorite.id }}/{{photo_6}}?rand={{rand}}">
                        </div>
                        <div class="col-md-6 pic_col">
                            <img class="picture img-fluid"
                                 src="{{apiUrl}}img/{{ favorite.id }}/{{photo_7}}?rand={{rand}}">
                        </div>
                        <div class="col-md-6 pic_col">
                            <img class="picture img-fluid"
                                 src="{{apiUrl}}img/{{ favorite.id }}/{{photo_8}}?rand={{rand}}">
                        </div>
                    </div>
                </div>
                <p class="bottom_link {{ pdfConfig.display_legal_notice ? 'with_legal_notice' : ''}}">
                    <span>purpleimmobilier.fr - Analyses et dossier effectués en partenariat avec
                        <img width="25" src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                </p>
                <img *ngIf="pdfConfig.visuel_1 != ''" class="bottom_img" src="{{ pdfConfig.visuel_1 }}"/>
            </div>
        </div>


        <div class="card">
            <div class="card-header">
                Sélection de photo
            </div>
            <div class="card-body picture_choice">
                <img (click)="photo_10 = 'meuble_pack_1';edit(null, 'pictures')"
                     [ngClass]="{active : photo_10 == 'meuble_pack_1'}"
                     src="/assets/pdf/purpleimmobilier/meuble_pack_1.png">
                <img (click)="photo_10 = 'meuble_pack_2';edit(null, 'pictures')"
                     [ngClass]="{active : photo_10 == 'meuble_pack_2'}"
                     src="/assets/pdf/purpleimmobilier/meuble_pack_3.png">
                <img (click)="photo_10 = 'meuble_pack_3';edit(null, 'pictures')"
                     [ngClass]="{active : photo_10 == 'meuble_pack_3'}"
                     src="/assets/pdf/purpleimmobilier/meuble_pack_3.png">
            </div>
        </div>

        <div id="livraison" class="page"
             [ngStyle]="{backgroundImage: 'url(/assets/pdf/purpleimmobilier/' + photo_10 + '.png)'}">
            <div class="subpage">
                <div class="subpageWrap">
                    <h2 class="{{ pdfConfig.h2_class}} mb-0">
                        Livraison
                    </h2>
                </div>
                <p class="bottom_link {{ pdfConfig.display_legal_notice ? 'with_legal_notice' : ''}}">
                    <span>purpleimmobilier.fr - Analyses et dossier effectués en partenariat avec
                        <img width="25" src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                </p>
                <img *ngIf="pdfConfig.visuel_1 != ''" class="bottom_img" src="{{ pdfConfig.visuel_1 }}"/>
            </div>
        </div>

        <div id="livraison2" class="page">
            <div class="subpage">
                <div class="subpageWrap">
                    <h2 class="{{ pdfConfig.h2_class}} mb-0">
                        Livraison
                    </h2>
                </div>
                <p class="bottom_link {{ pdfConfig.display_legal_notice ? 'with_legal_notice' : ''}}">
                    <span>purpleimmobilier.fr - Analyses et dossier effectués en partenariat avec
                        <img width="25" src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                </p>
                <img *ngIf="pdfConfig.visuel_1 != ''" class="bottom_img" src="{{ pdfConfig.visuel_1 }}"/>
            </div>
        </div>

        <div class="text-center mb-4 mt-5">
            <label>Loyer plafonné : </label>
            <input type="text" class="input_title ms-4" [(ngModel)]="loyer_plafond"
                   (ngModelChange)="edit($event, 'distance')" placeholder="Loyer plafonné">
        </div>

        <div id="finance" class="page">
            <div class="subpage">
                <div class="subpageWrap">
                    <h2 class="{{ pdfConfig.h2_class}}">
                        Bilan
                    </h2>
                    <div [ngClass]="{'kpi-4': loyer_plafond != '', 'kpi-3' : loyer_plafond == ''}">
                        <div class="kpi kpi-color-1">
                            <img class="icon" src="assets/050-wallet_white.png"/>
                            <label>Loyer mensuel HC</label>
                            <p class="value">{{ favorite.amount_rent | number: '1.0-0' }} €</p>
                        </div>
                        <div *ngIf="loyer_plafond != ''" class="kpi kpi-color-1">
                            <img class="icon" src="assets/050-wallet_white.png"/>
                            <label>Loyer plafonné</label>
                            <p class="value">{{ loyer_plafond }} €</p>
                        </div>
                        <div class="kpi kpi-color-2">
                            <img class="icon" src="assets/009-get-money_white.png"/>
                            <label>Rendement brut</label>
                            <p class="value">{{ favorite.efficiency_brut | number: '1.1-1' }} %</p>
                        </div>
                        <div class="kpi kpi-color-3">
                            <img class="icon" src="assets/030-cash.png"/>
                            <label>Épargne</label>
                            <p class="value">{{ favorite.cash_flow | number: '1.0-0' }} €</p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-5">
                            <div class="card">
                                <div class="card-header">
                                    <div class="card-title">
                                        <h3 class="{{ pdfConfig.h3_class}} text-color">Répartition des charges
                                            mensuelles</h3>
                                    </div>
                                </div>
                                <div class="card-body col-md-12">
                                    <div class="card-text row">
                                        <div echarts [options]="chargeOptions" [merge]="chargeData" class="chargeChart"
                                             (chartInit)="onChargeChartInit($event)"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 achat_credit">
                            <div class="card block_recap">
                                <div class="card-header">
                                    <div class="card-title">
                                        <h3 class="{{ pdfConfig.h3_class}} text-color">Achat</h3>
                                    </div>
                                </div>
                                <div class="card-body col-md-12">
                                    <div class="card-text row">
                                        <table>
                                            <tr>
                                                <th>Prix d'achat</th>
                                                <td>{{ favorite.price|number:'1.0-1' }} €</td>
                                            </tr>
                                            <tr>
                                                <th>Surface</th>
                                                <td>{{ favorite.square|number:'1.0-1' }} m²</td>
                                            </tr>
                                            <tr>
                                                <th>Droits de mutation</th>
                                                <td>{{ favorite.notary_price|number:'1.0-1' }} €</td>
                                            </tr>
                                            <tr>
                                                <th>Accompagnement purple</th>
                                                <td>{{ favorite.other_fees|number:'1.0-1' }} €</td>
                                            </tr>
                                            <tr>
                                                <th>Meubles</th>
                                                <td>{{ favorite.furniture_price|number:'1.0-1' }} €</td>
                                            </tr>
                                            <tr>
                                                <th>Travaux</th>
                                                <td>{{ favorite.works_total + favorite.other_fees_work |number:'1.0-1' }}
                                                    €
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Total achat</th>
                                                <td><b>{{ favorite.total_price|number:'1.0-1' }} €</b></td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="card block_recap">
                                <div class="card-header">
                                    <div class="card-title">
                                        <h3 class="{{ pdfConfig.h3_class}} text-color">Crédit </h3>
                                    </div>
                                </div>
                                <div class="card-body col-md-12">
                                    <div class="card-text row">
                                        <table>
                                            <tr>
                                                <th>Apport</th>
                                                <td>{{ favorite.apport|number:'1.0-1' }} €</td>
                                            </tr>
                                            <tr>
                                                <th>Frais de cautionnement</th>
                                                <td>{{ favorite.deposit_fees|number:'1.0-1' }} €</td>
                                            </tr>
                                            <tr>
                                                <th>Taux crédit</th>
                                                <td>{{ favorite.rate|number:'1.0-1' }} %</td>
                                            </tr>
                                            <tr>
                                                <th>Taux assurance</th>
                                                <td>{{ favorite.rate_insurance|number:'1.0-1' }} %</td>
                                            </tr>
                                            <tr>
                                                <th>Durée</th>
                                                <td>{{ favorite.duration|number:'1.0-1' }} ans</td>
                                            </tr>
                                            <tr>
                                                <th>Annuité</th>
                                                <td>{{ favorite.monthly * 12|number:'1.0-1' }} €</td>
                                            </tr>
                                            <tr>
                                                <th>Mensualité</th>
                                                <td>{{ favorite.monthly|number:'1.0-1' }} €</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="card block_recap">
                                <div class="card-header">
                                    <div class="card-title">
                                        <h3 class="{{ pdfConfig.h3_class}} text-color">Charges annuelles</h3>
                                    </div>
                                </div>
                                <div class="card-body col-md-12">
                                    <div class="card-text row">
                                        <table>
                                            <tr>
                                                <th>Taxe foncière</th>
                                                <td>
                                                    {{ favorite.amount_property_tax }} €/an
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Assurance PNO</th>
                                                <td>
                                                    {{ favorite.building_insurance }} €/an
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Gestion agence ({{ favorite.agence }} %)</th>
                                                <td>
                                                    {{ favorite.amount_rent * favorite.agence / 100 * 12 |number:'1.0-1' }}
                                                    €/an
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Frais de relocation</th>
                                                <td>
                                                    {{ favorite.agence_rental }} €/an
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Garantie loyers impayés ({{ favorite.amount_rent_insurance }}%)
                                                </th>
                                                <td>
                                                    {{ favorite.amount_rent * favorite.amount_rent_insurance / 100 * 12 |number:'1.0-1' }}
                                                    €/an
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Charges de copropriété</th>
                                                <td>
                                                    {{ favorite.amount_copro }} €/an
                                                </td>
                                            </tr>
                                            <!--                                <tr>-->
                                            <!--                                    <th>Charges de copropriété locataire</th>-->
                                            <!--                                    <td>-->
                                            <!--                                        {{favorite.amount_copro_rent}} €/an-->
                                            <!--                                    </td>-->
                                            <!--                                </tr>-->
                                            <tr>
                                                <th>Vacance locative ({{ favorite.rental_vacancy }} mois /an)</th>
                                                <td>
                                                    {{ favorite.amount_rent * favorite.rental_vacancy |number:'1.0-1' }}
                                                    €/an
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Autres frais</th>
                                                <td>
                                                    {{ favorite.other_bill }} €/an
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Comptabilité / CFE</th>
                                                <td>
                                                    {{ favorite.accouting_fees + favorite.cfe_contribution }}
                                                    €/an
                                                </td>
                                            </tr>
                                            <tr>
                                                <th style="padding-top: 2px;">Total</th>
                                                <td style="padding-top: 2px;">
                                                    <b>{{ favorite.charge * 12 | number: '1.0-0' }} €/an</b>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="bottom_link {{ pdfConfig.display_legal_notice ? 'with_legal_notice' : ''}}">
                    <span>purpleimmobilier.fr - Analyses et dossier effectués en partenariat avec
                        <img width="25" src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                </p>
            </div>
        </div>

        <div id="finance_2" class="page">
            <div class="subpage">
                <div class="subpageWrap" id="table_bilan">
                    <div class="kpi-4">
                        <div class="kpi kpi-color-1">
                            <img class="icon" src="assets/050-wallet_white.png"/>
                            <label>Cash flow moyen</label>
                            <p class="value">{{ result[result.length - 1]?.treso_revente / favorite.selling_year / 12 | number: '1.0-0' }}
                                €</p>
                        </div>
                        <div class="kpi kpi-color-1">
                            <img class="icon" src="assets/050-wallet_white.png"/>
                            <label>Prix de revente</label>
                            <p class="value">{{ favorite.selling_price | number: '1.0-0' }} €</p>
                        </div>
                        <div class="kpi kpi-color-2">
                            <img class="icon" src="assets/009-get-money_white.png"/>
                            <label>Enrichissement total</label>
                            <p class="value">{{ result[result.length - 1]?.treso_revente | number: '1.0-0' }} €</p>
                        </div>
                        <div class="kpi kpi-color-2">
                            <label>Évolution des prix sur 5 ans</label>
                            <p class="value">
                                <ng-container *ngIf="toFloat(favorite.ad_city.evol_prix_ville.evol_5y) > 0">+
                                </ng-container>
                                <ng-container
                                    *ngIf="favorite.ad_city.evol_prix_ville.evol_5y != ''">{{ toFloat(favorite.ad_city.evol_prix_ville.evol_5y) * 100 | number:'1.1-1' }}
                                    %
                                </ng-container>
                                <ng-container *ngIf="favorite.ad_city.evol_prix_ville.evol_5y == ''">-</ng-container>
                            </p>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                <h3 class="{{ pdfConfig.h3_class}}">Bilan comptable prévisionnel
                                    <ng-container *ngIf="favorite.selling == true"> avec revente</ng-container>
                                </h3>
                            </div>
                        </div>
                        <div class="card-body col-md-12">
                            <div class="card-text row">
                                <table mat-table class="bilan_comptable"
                                       [dataSource]="result | slice:0:favorite.duration + 1">
                                    <ng-container matColumnDef="amortissement">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Amortissement</span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.amortissement | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="annee">
                                        <th mat-header-cell *matHeaderCellDef>Année</th>
                                        <td mat-cell *matCellDef="let element"> {{ element.annee }}</td>
                                    </ng-container>

                                    <ng-container matColumnDef="base_imposable">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Base imposable
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.base_imposable | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="base_imposable_revente">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Base imposable
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.base_imposable_revente | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="cash_flow">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Cash-flow
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.cash_flow | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="cash_flow_revente">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Cash flow
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.cash_flow_revente | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="charges">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Charges
                                        </span></div>
                                        </th>
                                        <td mat-cell *matCellDef="let element"> {{ element.charges | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="cumul_deficit_benefice">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Cumul déficit ou bénéfice
-                                       </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.cumul_deficit_benefice | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="impot_plus_value">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Impôts sur la plus value
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.impot_plus_value | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="avantage_fiscal">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Avantage fiscal
                                         </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.avantage_fiscal | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="avantage_fiscal_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Avantage fiscal
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.avantage_fiscal_revente | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="impot_societes">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Impôts sur les sociétés
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.impot_societes | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="impot_societes_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Impôts sur les sociétés
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.impot_societes_revente | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="impot_societes_avec_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Impôts sur les sociétés avec revente
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.impot_societes_avec_revente | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="impots_revenus">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Impôts sur le revenu
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.impots_revenus | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="impots_revenus_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Impôts sur le revenu
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.impots_revenus_revente | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="prelev_sociaux">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Prélèvements sociaux
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.prelev_sociaux | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="prelev_sociaux_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Prélèvements sociaux
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.prelev_sociaux_revente | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="loyers_percus">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Loyers
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.loyers_percus | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="int_emprunt">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Intérêts d'emprunt
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.int_emprunt | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="renta_nette_impot">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Rendement net d'impôts
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.renta_nette_impot * 100 | number:'1.2-2' }}
                                            %
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="annuite">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Annuité
                                        </span></div>
                                        </th>
                                        <td mat-cell *matCellDef="let element"> {{ element.annuite | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="capital_restant_du">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Capital restant dû
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.capital_restant_du | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="report_charge">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Report de charge
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.report_charge | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="report_charge_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Report de charge
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.report_charge_revente | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="stock_charges">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Stock de charge
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.stock_charges | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="stock_charges_revente">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Stock de charge
                                        </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.stock_charges_revente | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="report_amortissement">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Report amortissement
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.report_amortissement | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="report_amortissement_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Report amortissement
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.report_amortissement_revente | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="stock_amortissement">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Stock amortissement
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.stock_amortissement | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="stock_amortissement_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Stock amortissement
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.stock_amortissement_revente | number: '1.0-0' }}
                                            €
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="cotisations_sociales">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Cotisations sociales
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.cotisations_sociales | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="cotisations_sociales_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Cotisations sociales
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.cotisations_sociales_revente | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="prix_revente">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <div><span>Prix de revente
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.prix_revente | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="treso_revente">
                                        <th class="two_line" mat-header-cell *matHeaderCellDef>
                                            <div><span>Trésorerie cumulée
                                            </span></div>
                                        </th>
                                        <td mat-cell
                                            *matCellDef="let element"> {{ element.treso_revente | number: '1.0-0' }}
                                            <ng-container *ngIf="!hideUnit"> €</ng-container>
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="bottom_link {{ pdfConfig.display_legal_notice ? 'with_legal_notice' : ''}}">
                    <span>purpleimmobilier.fr - Analyses et dossier effectués en partenariat avec
                        <img width="25" src="assets/logo/logo-picto.png"/> www.lybox.fr<br/></span>
                </p>
            </div>
        </div>

        <div id="resume" class="page">
            <div class="subpage">
                <div class="subpageWrap">
                    <div class="col-md-3">
                        <h2 class="{{ pdfConfig.h2_class}}">
                            Synthèse
                        </h2>
                        <div class="kpi kpi-color-1">
                            <img class="icon" src="assets/search_budget.png"/>
                            <label>Prix FPI</label>
                            <p class="value">{{ favorite.total_price | number: '1.0-0' }} €</p>
                        </div>
                        <div class="kpi kpi-color-1">
                            <img class="icon" src="assets/search_budget.png"/>
                            <label>Rendement net</label>
                            <p class="value">{{ favorite.efficiency_net | number: '1.1-1' }} %</p>
                        </div>
                        <div class="kpi kpi-color-1">
                            <img class="icon" src="assets/analytics (4)_white.png"/>
                            <label>Loyer annuel</label>
                            <p class="value">{{ favorite.amount_rent * 12 | number: '1.0-0' }} €</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="final" class="page">
            <div class="subpage">
                <div class="subpageWrap">
                    <div class="row">

                    </div>
                </div>
            </div>
        </div>

        <button [hidden]="loading" [disabled]="!ready" (click)="createPdf()"
                class="dl_button btn btn-primary btn-lg text-white">
            <mat-spinner diameter="25" color="second" [hidden]="ready"></mat-spinner>
            <i class="fa cfa cfa-pdf text-white"></i> Télécharger le rapport
        </button>
        <mat-spinner diameter="25" color="second" [hidden]="!loading"></mat-spinner>
    </div>
</div>

<!-- Onboarding -->
<joyrideStep [stepContent]="pdfStepContent"
             joyrideStep="pdfStep"
             [stepContentParams]="{'user': authenticationService.currentUser}"
             (prev)="openDropdown()"
             stepPosition="center">
</joyrideStep>

<ng-template #pdfStepContent let-user="user">
    <div class="fs-6 user_onboarding_author">
        <img src="assets/Thomas.png" width="40px" class="me-3  rounded-circle"/><b>Thomas</b> de LyBox<br/>
    </div>
    <img src="assets/rapport_PDF.png" class="user_onboarding_visuel"/>
    <div class="p-2 user_onboarding_content">
        <h2 *ngIf="user.answer.profil == 'pro'">Impressionnez vos clients avec un rapport PDF à vos
            couleurs</h2>
        <h2 *ngIf="user.answer.profil != 'pro'">Impressionnez votre banquier avec un rapport
            PDF</h2>
        <p>
            Bienvenue dans la génération du rapport PDF de votre analyse.<br/>
            <br/>
            C’est ici que vous allez pouvoir <b>éditer votre rapport puis le télécharger</b>.<br/>
            <br/>
            Je vous montre !<br/>
        </p>
    </div>
</ng-template>

<ng-template #pdfAnnonceStepContent let-user="user">
    <div class="user_onboarding_content">
        <h2>Votre rapport sur mesure</h2>
        <p>
            Le rapport est constitué de plusieurs pages qui présentent les <b>différents aspects de votre projet
            :</b><br/>
        </p>
        <ul>
            <li>Présentation de l’annonce</li>
            <li>Analyse de la ville</li>
            <li>Analyse financière et fiscale</li>
        </ul>
        <p *ngIf="user.answer.profil == 'pro'">
            En tant que professionnel, vous pouvez <b>intégrer votre logo et vos couleurs sur ce rapport.</b>
        </p>
        <p>
            Le texte est modifiable directement en cliquant dessus.<br/>
            <br/>
            Les chiffres sont ceux que vous avez renseignés dans votre simulation.
        </p>
    </div>
</ng-template>

<ng-template #pdfPageStepContent>
    <div class="user_onboarding_content">
        <h2>Sélection des pages</h2>
        <p>
            Avant de télécharger votre rapport, vous pouvez choisir les pages qui vous intéressent.<br/>
            <br/>
            Celles qui ne sont pas cochées n'apparaîtront pas dans votre rapport au moment du téléchargement.
        </p>
    </div>
</ng-template>

<ng-template #pdfDownloadStepContent let-user="user">
    <div class="user_onboarding_content">
        <h2>Télécharger le rapport</h2>
        <p>
            Pour télécharger le rapport en PDF, cliquez ici !<br/>
            <br/>
            La génération du rapport peut prendre plusieurs minutes si vous êtes en haute définition.<br/>
        </p>
        <p *ngIf="user.answer.profil != 'pro'">
            Alors, qui va impressionner son banquier ? 💪
        </p>
        <p *ngIf="user.answer.profil == 'pro'">
            Alors, qui va impressionner ses clients ? 💪
        </p>
    </div>
</ng-template>
